<template><div><h1 id="ausweichartikel" tabindex="-1"><a class="header-anchor" href="#ausweichartikel"><span>Ausweichartikel</span></a></h1>
<p>Ausweichartikel im Detail — Information über Alternativen zum Artikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle dient der Benutzerinformation. Es kann festgehalten werden, ob für einen bestimmten Artikel eine Alternative vorhanden ist. Es ist aber keine Funktionalität damit verbunden.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Artikel (Kurzform):</dt>
<dd>Standardinformation zum Artikel</dd>
</dl>
<p>Artikel: Artikelnummer</p>
<p>Artikelbezeichnung</p>
<p>VPreis: Verkaufspreis aus Artikelstamm</p>
<p>verfügbar: Summe verfügbarer Artikel aus allen Lagern</p>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>gehezu:</dt>
<dd>Suchen nach Artikel</dd>
<dt>Filter:</dt>
<dd>Artikelfilter benutzen</dd>
<dt>erfassenA:</dt>
<dd>Erfassen Ausweichartikel. Es kann nur die Artikelnummer eingegeben werden, die übrigen Daten werden lediglich angezeigt</dd>
<dt>löschenA:</dt>
<dd>Löschen eines Ausweichartikels</dd>
<dt>Index:</dt>
<dd>Index nach Artikel</dd>
<dt>übersicht:</dt>
<dd>Übersichtsfenster Artikel zur manuellen Auswahl eines Artikels</dd>
<dt>drucken:</dt>
<dd>(nicht installiert)</dd>
<dt>vArt:</dt>
<dd>Vorheriger Artikel gemäss Index</dd>
<dt>nArt:</dt>
<dd>Nächster Artikel gemäss Index</dd>
<dt>./.:</dt>
<dd>Umfeldmenü</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


